var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0243C0 8.9786 8.95431 0.024292 20 0.024292C31.0457 0.024292 40 8.9786 40 20.0243C40 31.07 31.0457 40.0243 20 40.0243C8.95431 40.0243 0 31.07 0 20.0243Z",
    fill: "#ECEDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23.0243V27.0243C29 27.5547 28.7893 28.0634 28.4142 28.4385C28.0391 28.8136 27.5304 29.0243 27 29.0243H13C12.4696 29.0243 11.9609 28.8136 11.5858 28.4385C11.2107 28.0634 11 27.5547 11 27.0243V23.0243",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.0243L20 11.0243L15 16.0243",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.0243V23.0243",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.3cc8a48fcad3a7fa66d3a9741282e3fd.svg";
export { ForwardRef as ReactComponent };